import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';
import { TestimonialsSlider } from '../../../../../components/common/testimonials.slider';

import './testimonials.less';

const testimonials = [
  {
    title: 'Lidya has helped us increase our marketing projects and reach more people.',
    name: 'Ibrahim Agiri',
    position: 'MD/CEO Ajebo Market',
  },
  {
    title: 'Lidya financing was a life saver for our business. Processing was Swift and repayment quite convenient.',
    name: 'Adebayo Azeez',
  },
  {
    title: 'Trustworthy behavior, clear points, smooth collaboration, fulfill agreements.',
    name: 'Eco-stations',
    position: 's.r.o.',
  },
  {
    title: 'Lidya in a great measure has been a source of relief from business pressure to me as a result of her prompt and reliable assistance financially.',
    name: 'Solomon Ekwubiri',
  },
  {
    title: 'All I can say about lidya is nothing but to say Thank you because it help me greatly in increasing my business.',
    name: 'Sani Garba',
  },
  {
    title: 'Lidya has been consistently helping businesses to grow and expand.',
    name: 'Lamidi Abiodun',
  },
  {
    title: 'My rating of Lidya is 5 stars. The support of our Bakery Business through financing over the last two years had been enormous and impactful. The support had enabled us to increase our production capacity in terms of buying raw materials needed for production. Looking forward to more support now and in the future.',
    name: 'Ayobami Ogunkeye',
  },

];

const Testimonials = () => (
  <div className="o-testimonials">
    <div className="m-globalContentContainer m-testimonials__container">
      <div className="m-testimonials__titleContainer">
        <div className="-page-title a-landingPage__title">
          <Trans>testimonials.title</Trans>
        </div>
      </div>
      <div className="m-testimonials__imageContainer">
        <StaticImage
          src="../../../../images/getLoan/icon_quotes.svg"
          alt="quotes image"
          title="quotes"
          className="m-testimonials__image"
        />
      </div>
      <TestimonialsSlider testimonials={testimonials} />
    </div>
  </div>
);

export default Testimonials;
